import { render, staticRenderFns } from "./AppSettingsSchoolCap.vue?vue&type=template&id=45cea18a&"
import script from "./AppSettingsSchoolCap.vue?vue&type=script&lang=js&"
export * from "./AppSettingsSchoolCap.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsSchoolCap.vue?vue&type=style&index=0&id=45cea18a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports